import React from "react";

export class SimpleButton extends React.Component<{
	onClick: () => void;
	label: string;
	className?: string;
}> {
	render() {
		const { onClick, label, className } = this.props;
		return (
			<button className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ${className || ""}`} onClick={onClick}>
				{label}
			</button>
		);
	}
}
